import { Shield, ArrowRight } from "lucide-react";
import { Button } from "antd";

export function VerificationSection() {
  return (
    <section className="py-16 bg-[#80E280]/5 text-base">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-card border border-border rounded-2xl p-8 shadow-lg">
          <div className="flex items-center justify-center space-x-6">
            <div className="flex-shrink-0">
              <div className="w-16 h-16 bg-[#80E280]/10 rounded-full flex items-center justify-center">
                <Shield className="h-8 w-8 text-primary" />
              </div>
            </div>

            <div className="flex-1 text-center lg:text-left">
              <h3 className="text-2xl font-bold text-card-foreground mb-2">
                Verified Identity. Safer Connections.
              </h3>
              <p className="text-muted-foreground mb-4">
                Every community member is verified to protect students and
                ensure high-quality guidance.
              </p>

              <Button
                variant="outlined"
                className="group bg-transparent text-base p-4"
              >
                Learn about verification
                <ArrowRight className="ml-2 h-4 w-4 group-hover:translate-x-1 transition-transform" />
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
